<script setup lang="ts">
defineProps({ blok: Object })

const { state } = useAppStore()

const categories = ref(state.categories.map((category) => {
    return {
        ...category,
        open: false,
    }
}))
</script>

<template>
    <section class="section">
        <UiContainer max-width="max-w-2xl">
            <header class="global-header">
                <StoryblokRichText :doc="blok?.header" />
            </header>
        </UiContainer>
        <UiContainer>
            <div class="flex flex-wrap justify-center -m-6">
                <div
                    v-for="(category, index) in categories"
                    :key="category.id"
                    class="w-1/4 p-6 max-[1025px]:w-1/3 max-[769px]:w-1/2 max-[641px]:w-full"
                >
                    <UiCard
                        :label="category.name"
                        :icon="category.icon"
                        :color-mode="index % 2 === 0 ? 'light' : 'dark'"
                        @on-open="category.open = true"
                    />
                </div>
            </div>
        </UiContainer>
        <UiContainer max-width="max-w-2xl">
            <footer class="global-header mt-20">
                <StoryblokRichText :doc="blok?.footer" />
            </footer>
        </UiContainer>
        <UModal
            v-for="(category, index) in categories"
            :key="category.id"
            :open="category.open"
            :title="category.name"
            dismissible
            :description="category.name"
            :ui="{
                content: 'border border-chsc-indigo-500',
            }"
            class="max-w-4xl sm:max-w-4xl rounded-[40px] overflow-hidden"
        >
            <template #content>
                <UiCardModal
                    :label="category.name"
                    :content="category.content"
                    :color-mode="index % 2 === 0 ? 'light' : 'dark'"
                    @on-close="category.open = false"
                />
            </template>
        </UModal>
    </section>
</template>
